var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',{attrs:{"placement":"bottom"},on:{"click":_vm.toDetail}},[_c('template',{slot:"title"},[_c('span',[_vm._v("提示文档")])]),_c('img',{staticStyle:{"height":"23px","width":"23px"},attrs:{"src":"/common/notice.png"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }